export const initHomepageDialogNextSteps = () => {
  const dialogNextSteps = document.getElementById("dialog-next-steps") as HTMLDialogElement;

  if (!dialogNextSteps) {
    return;
  }

  const dialogNextStepsScrollToCenterButtons: NodeListOf<HTMLButtonElement> =
    document.querySelectorAll(".dialog-next-steps-scroll-to-center");

  const dialogNextStepsBody = dialogNextSteps.querySelector(".dialog-body") as HTMLDivElement;
  const activeStep = dialogNextStepsBody.querySelector(".active-step") as HTMLDivElement;

  if (
    !dialogNextSteps ||
    !dialogNextStepsScrollToCenterButtons ||
    !dialogNextStepsBody ||
    !activeStep
  ) {
    return;
  }

  dialogNextStepsScrollToCenterButtons.forEach((dialogNextStepsScrollToCenterButton) => {
    dialogNextStepsScrollToCenterButton.addEventListener("click", () => {
      // Scroll the div
      dialogNextSteps.scrollTo({
        top: activeStep.offsetTop / 1.5 - 157,
        behavior: "smooth",
      });
    });
  });
};
